import { DriveItemId } from '@/drive/entities/DriveItemId';

export function resolveTemporaryItems<T extends { id: DriveItemId }>(
  siblings: T[],
  resolvedItemByTempId: Map<DriveItemId, Nullable<T>>,
): T[] {
  return siblings
    .filter((sibling) => resolvedItemByTempId.get(sibling.id) !== null)
    .map((sibling) => resolvedItemByTempId.get(sibling.id) ?? sibling);
}
